import { MotStatus } from 'Types/motData';

export default {
	advisories: 'Advisories',
	allClear: 'All clear',
	fallback: '-',
	lastMotDate: 'Last MOT date',
	motStatus: 'MOT status',
	status: {
		[MotStatus.Exempt]: 'Exempt',
		[MotStatus.Fail]: 'Fail',
		[MotStatus.Pass]: 'Pass',
		[MotStatus.Unavailable]: 'Not available',
	},
};
